import React, { FC } from 'react';
import { Col, Row, Typography } from 'antd';
import Icon from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@modules/me';
import * as CashFlowIcons from '../assets/icons';

const CardLink: FC<{ to: string; icon: React.ReactNode; title: string }> = ({ to, icon, title }) => (
  <NavLink to={to} style={{ display: 'block', height: '100%', padding: '3rem 0', background: '#fff', textAlign: 'center', color: '#0A4755', textDecoration: 'none' }}>
    <span style={{ fontSize: 40 }}>{icon}</span>
    <h1 style={{ margin: 0, color: 'inherit' }}>{title}</h1>
  </NavLink>
);

export const CashFlowOverviewPage: FC = () => {
  const { can } = useAuth();

  return (
    <div>
      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <Typography.Title level={3} style={{ marginBottom: 0 }}>
            Cashflow
          </Typography.Title>
        </Col>
        <Col xs={24} lg={12}>
          <CardLink to="/cash-flow/analytics" icon={<Icon component={CashFlowIcons.BarChartOutlined} />} title="Analitika" />
        </Col>
        {can('cashbox_operations.r') && (
          <Col xs={24} lg={12}>
            <CardLink to="/cash-flow/transactions" icon={<Icon component={CashFlowIcons.TransferOutlined} />} title="Tranzaksiyalar" />
          </Col>
        )}
        {can('cashboxes.r') && (
          <Col xs={24} lg={8}>
            <CardLink to="/cash-flow/cash-registers" icon={<Icon component={CashFlowIcons.CashRegisterOutlined} />} title="Kassalar" />
          </Col>
        )}
        <Col xs={24} lg={8}>
          <CardLink to="/cash-flow/currencies" icon={<Icon component={CashFlowIcons.ExchangeOutlined} />} title="Valyutalar" />
        </Col>
        {can('cash_categories.r') && (
          <Col xs={24} lg={8}>
            <CardLink to="/cash-flow/operations" icon={<Icon component={CashFlowIcons.OperationsOutlined} />} title="Əməliyyat kateqoriyaları" />
          </Col>
        )}
      </Row>
    </div>
  );
};
